import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomRadioButton from '@s-ui/react-atom-radio-button'
import AtomTextarea from '@s-ui/react-atom-textarea'
import Context from '@s-ui/react-context'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {RADIO_BUTTONS_IDS} from '../utils.js'

export const UnsubscribeEmailsRadioButtonsForm = ({
  formValueSelected,
  handleClick,
  handleOnChangeOtherReasonTextArea,
  otherReasonTextArea
}) => {
  const {i18n} = useContext(Context)

  const radioButtonsFormTitle = i18n.t('UNSUBSCRIBE_EMAILS_PAGE.RADIO_BUTTONS.TITLE')
  const {NOT_WELL_VISUALIZED, NO_LONGER_INTERESTED, TOO_OFTEN, OTHERS} = RADIO_BUTTONS_IDS

  const radioButtons = [
    {id: NO_LONGER_INTERESTED, text: i18n.t('UNSUBSCRIBE_EMAILS_PAGE.RADIO_BUTTONS.LABEL_1')},
    {id: TOO_OFTEN, text: i18n.t('UNSUBSCRIBE_EMAILS_PAGE.RADIO_BUTTONS.LABEL_2')},
    {id: NOT_WELL_VISUALIZED, text: i18n.t('UNSUBSCRIBE_EMAILS_PAGE.RADIO_BUTTONS.LABEL_3')},
    {id: OTHERS, text: i18n.t('UNSUBSCRIBE_EMAILS_PAGE.RADIO_BUTTONS.LABEL_4')}
  ]

  const showTextArea = formValueSelected === OTHERS
  return (
    <>
      <div className="mt-UserUnsubscribeEmails-radioButtonsTitle">
        <TitleBasic as={titleBasicTags.h5} size={titleBasicSizes.xs} title={radioButtonsFormTitle} />
      </div>
      {radioButtons.map(({id, text}) => (
        <div className="mt-UserUnsubscribeEmails-radioButton" key={id}>
          <AtomRadioButton checked={formValueSelected === id} id={id} onChange={e => handleClick({e, id})} />
          <span className="mt-UserUnsubscribeEmails-label">{text}</span>
        </div>
      ))}
      {showTextArea && (
        <div className="mt-UserUnsubscribeEmails-textArea">
          <AtomTextarea
            onChange={handleOnChangeOtherReasonTextArea}
            placeholder={i18n.t('UNSUBSCRIBE_EMAILS_PAGE.RADIO_BUTTONS.PLACEHOLDER')}
            value={otherReasonTextArea}
          />
        </div>
      )}
    </>
  )
}

UnsubscribeEmailsRadioButtonsForm.propTypes = {
  formValueSelected: PropTypes.string,
  handleClick: PropTypes.func,
  handleOnChangeOtherReasonTextArea: PropTypes.func,
  otherReasonTextArea: PropTypes.string
}
